import styled from 'styled-components';
import { color, spacing } from '~/theme';

export const FormFieldset = styled.fieldset`
    border: 0;
    margin: 0;
    padding: 0;
    page-break-inside: avoid;

    &.withBorder {
        border: 1px solid ${color.palette.greyscale20};
        padding: ${spacing.spacing5};
    }

    &.disabled {
        color: ${color.palette.greyscale20};
    }
`;

export default FormFieldset;
